<script setup lang="ts">
  import Brand from '~/assets/images/brand.png';
  import LogoScan from '~/assets/images/LogoScan.vue';
  import { useSplashStore } from '~/stores/useSplashStore';

  const AUTH_STORE = useAuthStore();
  const { authenticated } = storeToRefs(AUTH_STORE);

  const splashStore = useSplashStore();
  const { message } = storeToRefs(splashStore);

  const brand = computed(() => Brand);
  const showLogo = ref(false);
  const logoOnStart = ref(false);
  const showText = ref(false);
  const showInfo = ref(false);

  setInterval(() => {
    showLogo.value = true;
    showInfo.value = true;
  }, 1000);

  setInterval(() => {
    logoOnStart.value = true;
    showText.value = true;
  }, 2000);
</script>
<template>
  <Transition appear>
    <div class="wrapper">
      <LogoScan
        class="logo transition"
        :class="[
          {
            visible: showLogo,
            invisible: !showLogo,
            'on-start': logoOnStart,
            'on-center': !logoOnStart,
          },
        ]"
      />

      <h1
        class="title transition"
        :class="[{ invisible: !showText }]"
      >
        MyScanSource
      </h1>
      <sub
        class="subtitle transition"
        :class="[{ invisible: !showText }]"
      >
        obrigado por escolher o MyScanSource
      </sub>

      <sub
        v-if="!authenticated"
        class="subtitle info transition"
        :class="[{ invisible: !showInfo }]"
      >
        {{ message }}
      </sub>

      <img
        :src="brand"
        alt="brand"
        class="brand"
      />
    </div>
  </Transition>
</template>

<style scoped>
  .wrapper {
    @apply h-screen w-screen flex flex-col items-center justify-center relative overflow-hidden;
  }

  .logo {
    @apply absolute mx-auto z-10;
    @apply lg:scale-110 2xl:scale-150;
  }

  .brand {
    @apply z-0;
    @apply absolute bottom-[-10%] right-[-40%];
    @apply md:bottom-[-30%] md:right-[-40%] md:scale-75;
    @apply lg:bottom-[-40%] lg:scale-[60%];
    @apply xl:right-[-30%] xl:bottom-[-50%] 2xl:bottom-[-40%] 2xl:right-[-20%];
  }
  .title {
    @apply z-10;
    @apply text-3xl font-bold font-inter leading-10;
    @apply text-transparent bg-clip-text bg-gradient-to-r from-secondary to-primary;
    @apply drop-shadow-md;
    @apply translate-x-0 opacity-100 origin-left delay-500;
    @apply lg:text-4xl  2xl:text-6xl;
  }
  .subtitle {
    @apply z-10;
    @apply font-medium font-montserrat lowercase text-surface-600 leading-snug;
    @apply delay-700;
    @apply translate-y-0 opacity-100 origin-top;
    @apply lg:text-base 2xl:text-xl;
  }

  .info {
    @apply absolute bottom-4 lg:bottom-8 opacity-100;
  }
  .info.invisible {
    @apply opacity-0;
  }
  .logo.invisible {
    @apply opacity-0;
  }
  .logo.visible {
    @apply opacity-100;
  }

  .logo.on-start {
    @apply top-4 lg:top-8;
  }

  .logo.on-center {
    @apply top-1/2;
  }

  .title.invisible {
    @apply -translate-x-1/3 opacity-0;
  }
  .subtitle.invisible {
    @apply translate-y-1/4 opacity-0;
  }
  .transition {
    @apply transition-all duration-500 ease-in-out;
  }
</style>
